export enum EProcessSearchResultsModes {
    business = 0,
    treasures = 1
}
